import classNames from "classnames";
import {observer} from "mobx-react";
import React from "react";
import UI from "../UI";

export interface UIPaginationBarParam {
    totalCnt: number;
    rowCnt: number;
    pageCnt?: 5 | 10 | 20 | 50 | 100;
    currentPage: number;

    onChange(currentPage: number): void;
}

export default observer(UIPaginationBar);

function UIPaginationBar({totalCnt, rowCnt, currentPage, pageCnt = 10, onChange}: UIPaginationBarParam) {

    const {totalPage, pageNoButtons} = React.useMemo(() => {
        const totalPage = Math.ceil(totalCnt / rowCnt);
        const startPage = Math.ceil(currentPage / pageCnt) * pageCnt - (pageCnt - 1);
        const endPage = Math.min(startPage + pageCnt, (totalPage + 1));
        const pageNoButtons = Array.from({ length: (endPage - startPage) }, (_, i) => startPage + i).map(pageNo => (
            <button key={pageNo}
                    className={classNames("item", {active: currentPage === pageNo})}
                    onClick={() => {
                        onChange(pageNo);
                    }}
            >
                {pageNo}
            </button>
        ));

        return {totalPage, pageNoButtons};
    }, [totalCnt, rowCnt, currentPage, pageCnt, onChange]);

    return (
        <div className="pg">
            <UI.If test={currentPage > 1}>
                <div className={"group"}>
                    <button
                        type="button"
                        className="item first"
                        onClick={() => {
                            onChange(1);
                        }}
                    >
                        <a style={{cursor: "pointer"}}>처음</a>
                    </button>
                    <button
                        type="button"
                        className="item prev"
                        onClick={() => {
                            onChange(currentPage - 1);
                        }}
                    >
                        <a style={{cursor: "pointer"}}>이전</a>
                    </button>
                </div>
            </UI.If>
            <div className="group">
                {pageNoButtons}
            </div>
            <UI.If test={currentPage < totalPage}>
                <div className={"group"}>
                    <button
                        className={"item next"}
                        onClick={() => {
                            onChange(currentPage + 1);
                        }}
                    >
                        <a style={{cursor: "pointer"}}>다음</a>
                    </button>
                    <button
                        className={"item last"}
                        onClick={() => {
                            onChange(totalPage);
                        }}
                    >
                        <a style={{cursor: "pointer"}}>끝</a>
                    </button>
                </div>
            </UI.If>
        </div>
    );
}
